// extracted by mini-css-extract-plugin
export default {"topBar":"TopBar_topBar__tRpgj","menu":"TopBar_menu__4tcND","telegram":"TopBar_telegram__W6p06","whatsapp":"TopBar_whatsapp__MT+xb"};